export async function backlogGetBacklogStorageUseCase(date, backlogRepository) {

    const result = await backlogRepository.backlog_storage(date);

    const entity = new backlogRepository.model_storage(result.data.success.arguments)

    if (!entity.isValid()) {
        console.log(entity)
        throw new Error("Backlog storage response invalido");
    }

    return entity;
}